var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right"},[_vm._v("\n  "+_vm._s(_vm.params.value ? _vm.numberComma(_vm.params.value.toFixed(2)) + " %" : "-")+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }